export default __webpack_public_path__ + "static/media/0K9A1493.ea8a883d.jpg";